import { getMockRestRegistry, installMockRestInterceptor } from "./mock-rest";
import {
  getMockOverrides,
  isMockModeEnabled,
  resetMockOverrides,
  setMockModeEnabled,
  setMockOverride,
} from "./mock-storage";

declare global {
  interface Window {
    __redoMock: ReturnType<typeof buildMockApi>;
  }
}

function buildMockApi() {
  return {
    enable() {
      setMockModeEnabled(true);
      console.log("[redoMock] Mock mode enabled. Refresh the page.");
    },
    disable() {
      setMockModeEnabled(false);
      console.log("[redoMock] Mock mode disabled. Refresh the page.");
    },
    status() {
      const enabled = isMockModeEnabled();
      const overrides = getMockOverrides();
      console.log(`[redoMock] Global mock mode: ${enabled ? "ON" : "OFF"}`);
      const entries = Object.entries(overrides);
      if (entries.length > 0) {
        console.log("[redoMock] Per-RPC overrides:");
        for (const [name, mocked] of entries) {
          console.log(`  ${name}: ${mocked ? "mocked" : "real"}`);
        }
      } else {
        console.log("[redoMock] No per-RPC overrides.");
      }
      const restEndpoints = getMockRestRegistry();
      if (restEndpoints.length > 0) {
        console.log("[redoMock] Registered REST mocks:");
        for (const ep of restEndpoints) {
          console.log(`  ${ep.method ?? "GET"} ${ep.pattern}`);
        }
      }
    },
    mock(rpcName: string) {
      setMockOverride(rpcName, true);
      console.log(`[redoMock] ${rpcName} → mocked. Refresh to apply.`);
    },
    unmock(rpcName: string) {
      setMockOverride(rpcName, false);
      console.log(`[redoMock] ${rpcName} → real. Refresh to apply.`);
    },
    reset() {
      resetMockOverrides();
      console.log(
        "[redoMock] All per-RPC overrides cleared. Refresh to apply.",
      );
    },
  };
}

export function initMockConsoleApi(): void {
  installMockRestInterceptor();
  window.__redoMock = buildMockApi();
  console.log(
    "[redoMock] Console API ready. Try: __redoMock.enable() / __redoMock.status()",
  );
}
